import { render } from "./DataStatistics.vue?vue&type=template&id=7f12c843&scoped=true"
import script from "./DataStatistics.vue?vue&type=script&lang=js"
export * from "./DataStatistics.vue?vue&type=script&lang=js"

import "./DataStatistics.vue?vue&type=style&index=0&id=7f12c843&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f12c843"]])

export default __exports__